import { isEmpty } from './values'

export const getNonEmptyValuesObject = <T>(obj: T & Object) =>
  obj
    ? Object.keys(obj).reduce((prev, next) => {
        const currentFilter = obj[next as keyof T]
        return isEmpty(currentFilter)
          ? prev
          : { ...prev, [next]: currentFilter }
      }, {} as T)
    : {}

export const areObjectsEqual = (
  obj1: {
    [key: string]: any
  },
  obj2: {
    [key: string]: any
  }
) => {
  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)
  if (keys1.length !== keys2.length) return false
  return keys1.every(key => obj1[key] === obj2[key])
}

export const convertObjectEmptyValuesToNull = <T>(obj: Object & T) =>
  (Object.keys(obj) as (keyof T)[]).reduce(
    (acc, key) => ({
      ...acc,
      [key]: obj[key] || null,
    }),
    {} as T
  )

export const hasObjectAnyEmptyValue = <T>(obj: T) =>
  Object.values(obj).includes(null) || Object.values(obj).includes('')

export const convertObjectNullValuesToEmptyString = <T>(obj: Object & T) =>
  (Object.keys(obj) as (keyof T)[]).reduce(
    (acc, key) => ({
      ...acc,
      [key]:
        obj[key] &&
        ['number', 'string', 'object', 'boolean'].includes(typeof obj[key])
          ? obj[key]
          : '',
    }),
    {} as T
  )

export const invert = (obj: Object) =>
  Object.fromEntries(Object.entries(obj).map(a => a.reverse()))

export const hasAnyNonEmptyValue = (obj: Object) =>
  Object.values(obj).some(item => !!item)

export const isObjectEmpty = (obj: Object) => !Object.keys(obj).length

export const removeProperty = (obj: Object, property: string | number) =>
  Object.fromEntries(
    Object.entries(obj).filter(([key]) => key !== `${property}`)
  )
